import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Itinerary } from 'core/models';

@Component({
  selector: 'lms-itinerary-create',
  templateUrl: './itinerary-create.component.html',
  styleUrls: ['./itinerary-create.component.scss']
})
export class ItineraryCreateComponent implements OnInit {
  constructor(
    public location: Location,
    public router: Router,
    public translate: TranslateService,
    public titleService: Title
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('itineraries.create') +
        ' - ' +
        this.translate.instant('pageTitle.itinerary') +
        ' - ' +
        this.translate.instant('pageTitle.gamelearn')
    );
  }

  goBack() {
    this.location.back();
  }

  onSave(itinerary: Itinerary) {
    this.router.navigate(['/itineraries', itinerary.id], { replaceUrl: true, fragment: 'translate' });
  }
}
